import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="suppression"
//
// Presentational only: shows / hides the "Add entry" and "Bulk add" slide-over
// drawers on the Suppression surface. No business logic lives here — the drawers
// wrap the existing create / import forms, which POST exactly as before.
export default class extends Controller {
  static targets = ["addDrawer", "bulkDrawer", "fileName"]

  openAdd() { this.#open(this.addDrawerTarget) }
  openBulk() { this.#open(this.bulkDrawerTarget) }

  // Reflect the picked filename next to the styled "Choose file" button. The
  // native <input type=file> is visually hidden; this replaces the browser's
  // default "No file chosen" with a branded equivalent. No upload behaviour.
  showFilename(event) {
    if (!this.hasFileNameTarget) return
    const file = event.target.files && event.target.files[0]
    this.fileNameTarget.textContent = file ? file.name : "No file chosen"
    this.fileNameTarget.style.color = file ? "#4A4D63" : "#9094AD"
  }

  close() {
    if (this.hasAddDrawerTarget) this.#hide(this.addDrawerTarget)
    if (this.hasBulkDrawerTarget) this.#hide(this.bulkDrawerTarget)
  }

  // Close on Escape.
  keydown(event) {
    if (event.key === "Escape") this.close()
  }

  #open(drawer) {
    this.close()
    drawer.classList.remove("hidden")
    const field = drawer.querySelector("input[type=text], textarea")
    if (field) field.focus()
  }

  #hide(drawer) { drawer.classList.add("hidden") }
}
